import script from "./ToggleSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToggleSwitch.vue?vue&type=script&setup=true&lang=ts"

import "./ToggleSwitch.vue?vue&type=style&index=0&id=4620a6b7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4620a6b7"]])

export default __exports__